import React, { useState, useEffect } from "react";
import { Tooltip, Button, Select, Modal } from "antd";
import download from "../../../assets/Download_Icon1.svg";
import downloadWhite from "../../../assets/WhiteIcons/DownloadWhite_Icon1.svg";
import accoArrow from "../../../assets/acco_arrow-up.svg";
import accoArrowWhite from "../../../assets/WhiteIcons/acco_arrow-upWhite.svg";
import InfoIcon from "../../../assets/Info_Icon.svg";
import refresh from "../../../assets/refresh.svg";
import refreshWhite from "../../../assets/WhiteIcons/refresh_white.svg";

import ProfileImg from "../../../assets/deepDive/sample-image.svg";
import NotLogin from "../../../assets/Not_Login_Img.svg";
import LoginLate from "../../../assets/Login_late.svg";
import LogoutEarly from "../../../assets/Logout_early.svg";
import somethingWentWrong from "../../../assets/No_Data_Found.svg";
import { useSelector, useDispatch } from "react-redux";
import { Excel } from "antd-table-saveas-excel";
import AgentTable from "./AgentTable";
import { getPaneIndex, simpleKFormatterOnly } from "../../../redux/constants";
import {
  getTrendsData,
  setPreWidgetsData,
} from "../../../redux/actions/ApiCall";
import AgentActivityTrends from "./AgentActivityTrends";
import moment from "moment";
import { setIsTicketTrandsView } from "../../../redux/actions/dashboard/Tab1";

const AgentActivityPage = ({ widgetsData }) => {
  const dispatch = useDispatch();
  const { Option } = Select;
  const panes = useSelector((state) => state?.Tab1?.panes);
  const authParams = useSelector((state) => state.Authentication.authParams);
  const activeKey = useSelector((state) => state?.Tab1?.activeKey);
  const brands = useSelector(
    (state) => state.ApiCall.brands?.data?.result?.brands
  );
  const preTicketLoader = useSelector(
    (state) => state.apiCall.ticketWidgetLoader
  );
  let index = getPaneIndex(panes, activeKey);

  const [selectOption, setSelectOption] = useState([]);
  const [agent, setAgent] = useState([]);
  const [pageSize, setPageSize] = useState(5);
  const [trandView, setTrandView] = useState(false);

  const columnsData = widgetsData?.graphData?.data?.columns?.map((Item, i) => {
    return Item?.title;
  });
  let columnsObj = [];
  for (let i = 0; i < columnsData?.length; i++) {
    columnsObj?.push({
      title: columnsData[i],
      dataIndex: columnsData[i],
      key: i,
    });
  }

  const secondsToDhms = (seconds) => {
    seconds = Number(seconds);
    var d = Math.floor(seconds / (3600 * 24));
    var h = Math.floor((seconds % (3600 * 24)) / 3600);
    var m = Math.floor((seconds % 3600) / 60);
    var s = Math.floor(seconds % 60);

    var dDisplay = d > 0 ? d + (d == 1 ? "D " : "D ") : "";
    var hDisplay = h > 0 ? h + (h == 1 ? "h " : "h ") : "";
    var mDisplay = m > 0 ? m + (m == 1 ? "m " : "m ") : "";
    var sDisplay = s > 0 ? s + (s == 1 ? "s" : "s") : "";
    return dDisplay + hDisplay + mDisplay + sDisplay;
  };
  const handleShowTreands = (d) => {
    setTrandView(true);
    let index = getPaneIndex(panes, activeKey);
    dispatch(setIsTicketTrandsView(true, panes, index));
    const payloadObj = {
      body: panes[index]?.sections?.[1]?.widgets?.[1]?.payload,
      teamUserId: d["Team User ID"] ? d["Team User ID"] : null,
      BrandIDs: d["BrandIDs"] ? d["BrandIDs"] : null,
      BrandName:
        d["BrandIDs"] && brands?.[0]?.brand_name
          ? brands?.[0]?.brand_name
          : null,
      payload: true,
    };
    authParams && dispatch(getTrendsData(payloadObj));
  };
  const getEndDateOfDuration = () => {
    let index = getPaneIndex(panes, activeKey);
    let endDate =
      panes?.[index]?.sections?.[1]?.widgets?.[1]?.payload?.end_date;
    if (endDate) {
      endDate = moment(endDate)?.format("DD MMM  YYYY");
    } else {
      endDate = moment()?.format("DD MMM  YYYY");
    }
    return endDate;
  };
  const endDateOfDuration = getEndDateOfDuration();
  useEffect(() => {
    if (widgetsData?.widget_id === "tickets_agent-activity_6") {
      let avg = [];
      Array.isArray(widgetsData?.graphData?.data?.dataSource) &&
        widgetsData?.graphData?.data?.dataSource?.map((d) => {
          avg.push({
            AgentsName: (
              <span
                id={d?.["Agents Name"]}
                className="d-flex align-items-center line-height-normal"
              >
                <span className="social__profile-pic mr-1 d-block">
                  <img
                    src={ProfileImg}
                    style={{ width: "3rem", borderRadius: "50%" }}
                    alt="Profile Img"
                  />
                  <span
                    className={
                      d?.["In/Out"] === "Login"
                        ? "potleta__online"
                        : "potleta__offline"
                    }
                  />
                </span>
                <span
                  className="cursor-pointer"
                  style={{
                    color: "#185edf",
                    textDecoration: "underline",
                  }}
                  onClick={() => {
                    handleShowTreands(d);
                  }}
                >
                  {d?.["Agents Name"]}
                </span>
              </span>
            ),
            InOut: (
              <span
                id={d["In/Out"]}
                className="d-flex align-items-center flex-wrap line-height-normal"
              >
                {d?.["In/Out"] === "Not Login" ? (
                  <div className="w-100 font-size12 mb-1">
                    <img
                      src={NotLogin}
                      style={{ width: "2rem", marginRight: "0.5rem" }}
                      alt="Not Login"
                    />
                    {d?.["In/Out"]}
                  </div>
                ) : (
                  <>
                    <div className="w-100 font-size12 mb-1">
                      {d?.["In/Out"]?.split("-")?.[0] && (
                        <img
                          src={LoginLate}
                          alt="Login Late"
                          className="mr-1"
                        />
                      )}{" "}
                      {d?.["In/Out"]?.split("-")?.[0]}{" "}
                    </div>
                    <div className="w-100 font-size12">
                      {d?.["In/Out"]?.split("-")?.[1] && (
                        <img
                          src={LogoutEarly}
                          alt="Logout Early"
                          className="mr-1"
                        />
                      )}
                      {d?.["In/Out"]?.split("-")?.[1]}
                    </div>
                  </>
                )}
              </span>
            ),
            AccountType: d["Account Type"],
            NOfLogouts: d["No. Of Logouts"],
            WorkingSince: (
              <span id={d["Working Since"]}>
                {secondsToDhms(d?.["Working Since"])
                  ? secondsToDhms(d?.["Working Since"])
                  : 0}
              </span>
            ),
            CustomersInteractedWith: d?.["Customers Interacted With"],
            CSDBrandsInteractedWith: d?.["CSD/ Brands Interacted With"],
            TicketsMentionsTagged: d?.["Tickets/ Mentions Tagged"],
            FirstResponseTAT: (
              <span
                id={d?.["First Response/ TAT"]}
                className="d-flex align-items-center flex-wrap line-height-normal"
              >
                <>
                  <div className="w-100 font-size12">
                    {d?.["First Response/ TAT"]}
                  </div>
                </>
              </span>
            ),
            NoOfBreaksTotalBreakTime: d?.["No. of Breaks/ Total Break Time"],
            TicketsWorkedOnTicketsPending:
              d?.["Tickets Worked On/ Tickets Pending"],
            AvgAgentActivity: (
              <span id={d?.["Avg. Agent Activity"]}>
                {d?.["Avg. Agent Activity"] === -1
                  ? "-"
                  : d?.["Avg. Agent Activity"] > 0
                  ? secondsToDhms(d?.["Avg. Agent Activity"])
                  : 0}
              </span>
            ),
            // AgentLoad: <span>{d?.["Agent Load"]}</span>,
          });
        });
      setAgent(avg);
    }
  }, [panes]);

  const AgentsList = [
    {
      title: <div style={{ minWidth: "12rem" }}>Agents Name</div>,
      dataIndex: "AgentsName",
      key: "1",
      sorter: (a, b) => {
        return a?.AgentsName?.props?.id?.localeCompare(
          b?.AgentsName?.props?.id
        );
      },
    },
    {
      title: (
        <div style={{ minWidth: "11rem" }}>
          In/Out <br /> (Today)
        </div>
      ),
      dataIndex: "InOut",
      key: "2",
      sorter: (a, b) => {
        return a?.InOut?.props?.id?.localeCompare(b?.InOut?.props?.id);
      },
    },
    {
      title: <div style={{ minWidth: "10rem" }}>Account Type</div>,
      dataIndex: "AccountType",
      key: "3",
      sorter: (a, b) => a?.AccountType?.localeCompare(b?.AccountType),
    },
    {
      title: <div style={{ minWidth: "10rem" }}>No. Of Logouts</div>,
      dataIndex: "NOfLogouts",
      key: "4",
      sorter: (a, b) => a?.NOfLogouts - b?.NOfLogouts,
    },
    {
      title: (
        <div style={{ minWidth: "10rem" }}>
          Working Since <br /> ({endDateOfDuration})
        </div>
      ),
      dataIndex: "WorkingSince",
      key: "5",
      sorter: (a, b) => {
        return a?.WorkingSince?.props?.id - b?.WorkingSince?.props?.id;
      },
    },
    {
      title: (
        <div className="line-height-normal" style={{ minWidth: "9rem" }}>
          Customers Interacted With
        </div>
      ),
      dataIndex: "CustomersInteractedWith",
      key: "6",
      sorter: (a, b) => a?.CustomersInteractedWith - b?.CustomersInteractedWith,
    },
    {
      title: (
        <div className="line-height-normal" style={{ minWidth: "10rem" }}>
          CSD/ Brands Interacted With
        </div>
      ),
      dataIndex: "CSDBrandsInteractedWith",
      key: "7",
      sorter: (a, b) => a?.CSDBrandsInteractedWith - b?.CSDBrandsInteractedWith,
    },
    {
      title: (
        <div className="line-height-normal" style={{ minWidth: "9rem" }}>
          Avg. Agent Activity
        </div>
      ),
      dataIndex: "AvgAgentActivity",
      key: "8",
      sorter: (a, b) =>
        a?.AvgAgentActivity?.props?.id - b?.AvgAgentActivity?.props?.id,
    },
    {
      title: (
        <div className="line-height-normal" style={{ minWidth: "10rem" }}>
          Tickets/ Mentions Tagged
        </div>
      ),
      dataIndex: "TicketsMentionsTagged",
      key: "9",
      sorter: (a, b) => a?.TicketsMentionsTagged - b?.TicketsMentionsTagged,
    },
    {
      title: (
        <div className="line-height-normal" style={{ minWidth: "10rem" }}>
          First Response | TAT
        </div>
      ),
      dataIndex: "FirstResponseTAT",
      key: "10",
      // sorter: (a, b) => a.FirstResponseTAT - b.FirstResponseTAT,
    },
    {
      title: (
        <div className="line-height-normal" style={{ minWidth: "10rem" }}>
          No. of Breaks | Total Break Time
        </div>
      ),
      dataIndex: "NoOfBreaksTotalBreakTime",
      key: "11",
      sorter: (a, b) => {
        let sub_str_a = a?.NoOfBreaksTotalBreakTime?.substring(
          0,
          a?.NoOfBreaksTotalBreakTime?.indexOf("|")
        );
        let sub_str_b = b?.NoOfBreaksTotalBreakTime?.substring(
          0,
          b?.NoOfBreaksTotalBreakTime?.indexOf("|")
        );
        return parseInt(sub_str_a) - parseInt(sub_str_b);
      },
    },
    {
      title: (
        <div style={{ minWidth: "12rem" }} className="line-height-normal">
          Tickets Worked On | Tickets Pending
        </div>
      ),
      dataIndex: "TicketsWorkedOnTicketsPending",
      key: "12",
      sorter: (a, b) => {
        let sub_str_a = a?.TicketsWorkedOnTicketsPending?.substring(
          0,
          a?.TicketsWorkedOnTicketsPending?.indexOf("|")
        );
        let sub_str_b = b?.TicketsWorkedOnTicketsPending?.substring(
          0,
          b?.TicketsWorkedOnTicketsPending?.indexOf("|")
        );
        return parseInt(sub_str_a) - parseInt(sub_str_b);
      },
    },
    // {
    //   title: (
    //     <div style={{ minWidth: "12rem" }} className="line-height-normal">
    //       Agent Load
    //     </div>
    //   ),
    //   dataIndex: "AgentLoad",
    //   key: "13",
    // },
  ];

  const AgentsList1 = [
    {
      title: "Agents Name",
      dataIndex: "AgentsName",
      key: "1",
      sorter: (a, b) => a.AgentsName.length - b.AgentsName.length,
    },
    {
      title: "In/Out",
      dataIndex: "InOut",
      key: "2",
      sorter: (a, b) => a.InOut.length - b.InOut.length,
    },
    {
      title: "Account Type",
      dataIndex: "AccountType",
      key: "3",
      sorter: (a, b) => a.AccountType.length - b.AccountType.length,
    },
    {
      title: "No. Of Logouts",
      dataIndex: "NOfLogouts",
      key: "4",
      sorter: (a, b) => a.NOfLogouts - b.NOfLogouts,
    },
    {
      title: "Working Since",
      dataIndex: "WorkingSince",
      key: "5",
      sorter: (a, b) => a.WorkingSince - b.WorkingSince,
    },
    {
      title: "Customers Interacted With",
      dataIndex: "CustomersInteractedWith",
      key: "6",
      sorter: (a, b) => a.CustomersInteractedWith - b.CustomersInteractedWith,
    },
    {
      title: "CSD/ Brands Interacted With",
      dataIndex: "CSDBrandsInteractedWith",
      key: "7",
      sorter: (a, b) => a.CSDBrandsInteractedWith - b.CSDBrandsInteractedWith,
    },
    {
      title: "Avg. Agent Activity",
      dataIndex: "AvgAgentActivity",
      key: "8",
      sorter: (a, b) => a.AvgAgentActivity - b.AvgAgentActivity,
    },
    {
      title: "Tickets/ Mentions Tagged",
      dataIndex: "TicketsMentionsTagged",
      key: "9",
      sorter: (a, b) => a.TicketsMentionsTagged - b.TicketsMentionsTagged,
    },
    {
      title: "First Response/ TAT",
      dataIndex: "FirstResponseTAT",
      key: "10",
      sorter: (a, b) => a.FirstResponseTAT - b.FirstResponseTAT,
    },
    {
      title: "No of Breaks/ Total Break Time",
      dataIndex: "NoOfBreaksTotalBreakTime",
      key: "11",
      sorter: (a, b) => a.NoOfBreaksTotalBreakTime - b.NoOfBreaksTotalBreakTime,
    },
    {
      title: "Tickets Worked On/ Tickets Pending",
      dataIndex: "TicketsWorkedOnTicketsPending",
      key: "12",
      sorter: (a, b) =>
        a.TicketsWorkedOnTicketsPending - b.TicketsWorkedOnTicketsPending,
    },
    // {
    //   title: "Agent Load",
    //   dataIndex: "AgentLoad",
    //   key: "13",
    // },
  ];

  const handleExport = () => {
    if (widgetsData?.widget_id === "tickets_agent-activity_6") {
      let avg = [];
      Array.isArray(widgetsData?.graphData?.data?.dataSource) &&
        widgetsData?.graphData?.data?.dataSource?.map((d) => {
          avg.push({
            AgentsName: d["Agents Name"],
            InOut: d["In/Out"],
            AccountType: d["Account Type"],
            NOfLogouts: d["No. Of Logouts"],
            WorkingSince: secondsToDhms(d["Working Since"])
              ? secondsToDhms(d["Working Since"])
              : 0,
            CustomersInteractedWith: d["Customers Interacted With"],
            CSDBrandsInteractedWith: d["CSD/ Brands Interacted With"],
            TicketsMentionsTagged: d["Tickets/ Mentions Tagged"],
            FirstResponseTAT: d["First Response/ TAT"],
            NoOfBreaksTotalBreakTime: d["No. of Breaks/ Total Break Time"],
            TicketsWorkedOnTicketsPending:
              d["Tickets Worked On/ Tickets Pending"],
            AvgAgentActivity: d["Avg. Agent Activity"],
            // AgentLoad: d["Agent Load"],
          });
        });

      const excel = new Excel();
      excel
        .addSheet("test")
        .addColumns(AgentsList1)
        .addDataSource(avg, {
          str2Percent: true,
        })
        .saveAs("Agents_List.xlsx");
    }
  };

  const handleGridData = (value, id, w_index) => {
    if (widgetsData?.widget_id == "tickets_agent-activity_6") {
      setPageSize(value);
      // let avg = [];
      // Array.isArray(widgetsData?.graphData?.data?.dataSource) &&
      //   widgetsData?.graphData?.data?.dataSource?.map((d) => {
      //     avg.push({
      //       AgentsName: (
      //         <span className="d-flex align-items-center line-height-normal">
      //           <span className="social__profile-pic mr-1 d-block">
      //             <img
      //               src={ProfileImg}
      //               style={{ width: "3rem", borderRadius: "50%" }}
      //               alt="Profile Img"
      //             />
      //             <span
      //               className={
      //                 d["In/Out"] === "Login"
      //                   ? "potleta__online"
      //                   : "potleta__offline"
      //               }
      //             />
      //           </span>
      //           {d["Agents Name"]}
      //         </span>
      //       ),
      //       InOut: (
      //         <span className="d-flex align-items-center flex-wrap line-height-normal">
      //           {d["In/Out"] === "Not Login" ? (
      //             <img
      //               src={NotLogin}
      //               style={{ width: "2rem", marginRight: "0.5rem" }}
      //               alt="Not Login"
      //             />
      //           ) : (
      //             ""
      //           )}
      //           {d["In/Out"] === "Not Login" ? (
      //             d["In/Out"]
      //           ) : (
      //             <>
      //               <div className="w-100 font-size12 mb-1">
      //                 {d["In/Out"].split("-")[0] && (
      //                   <img
      //                     src={LoginLate}
      //                     alt="Login Late"
      //                     className="mr-1"
      //                   />
      //                 )}{" "}
      //                 {d["In/Out"].split("-")[0]}{" "}
      //               </div>
      //               <div className="w-100 font-size12">
      //                 {d["In/Out"].split("-")[1] && (
      //                   <img
      //                     src={LogoutEarly}
      //                     alt="Logout Early"
      //                     className="mr-1"
      //                   />
      //                 )}
      //                 {d["In/Out"].split("-")[1]}
      //               </div>
      //             </>
      //           )}
      //         </span>
      //       ),
      //       AccountType: d["Account Type"],
      //       NOfLogouts: d["No. Of Logouts"],
      //       WorkingSince: (
      //         <span>
      //           {secondsToDhms(d["Working Since"])
      //             ? secondsToDhms(d["Working Since"])
      //             : 0}
      //         </span>
      //       ),
      //       CustomersInteractedWith: d["Customers Interacted With"],
      //       CSDBrandsInteractedWith: d["CSD/ Brands Interacted With"],
      //       TicketsMentionsTagged: d["Tickets/ Mentions Tagged"],
      //       FirstResponseTAT: (
      //         <span>
      //           {secondsToDhms(d["First Response/ TAT"])
      //             ? secondsToDhms(d["First Response/ TAT"])
      //             : 0}
      //         </span>
      //       ),
      //       NoOfBreaksTotalBreakTime: d["No. of Breaks/ Total Break Time"],
      //       TicketsWorkedOnTicketsPending:
      //         d["Tickets Worked On/ Tickets Pending"],
      //       AvgAgentActivity: (
      //         <span>
      //           {secondsToDhms(d["Avg. Agent Activity"])
      //             ? secondsToDhms(d["Avg. Agent Activity"])
      //             : 0}
      //         </span>
      //       ),
      //     });
      //   });
      // setAgent(avg);
    }
  };

  const handleRefresh = (widgetId) => {
    const payloadObj = {
      body: panes[index]?.sections[1]?.widgets[1]?.payload,
      payload: true,
      filters: panes[index]?.filters?.length ? panes[index]?.filters : null,
    };
    let indexes = {
      pane_index: index,
      section_index: null,
      panes: panes,
      widget_index: 5,
    };
    authParams?.category_id && dispatch(setPreWidgetsData(payloadObj, indexes));
  };

  useEffect(() => {
    let totalPages = Math.ceil(agent?.length / pageSize);
    totalPages = totalPages > 10 ? 10 : totalPages;
    let options = [];
    for (let i = 1; i <= totalPages; i++) {
      options?.push({
        value: `${5 * i}`,
        lable: `${5 * i}`,
      });
    }
    options && setSelectOption(options);
  }, [agent]);

  return (
    <>
      {widgetsData?.graphData &&
      !(
        preTicketLoader?.widget_id === widgetsData?.widget_id &&
        preTicketLoader?.value
      ) ? (
        widgetsData?.widget_id === "tickets_agent-activity_1" ? (
          <div className="d-flex flex-wrap text-center border border-color w-100 bg__white">
            <div
              className="border-right border-color p-4"
              style={{ flex: "1 0 calc(25% - 1.5rem)" }}
            >
              <div className="wm-chart-card-title mb-15 line-height-normal">
                {widgetsData?.graphData?.number_data &&
                  widgetsData?.graphData?.number_data[0]?.text}
                <Tooltip
                  title="These are the total number of tickets received by the brand"
                  placement="bottom"
                >
                  <img
                    src={InfoIcon}
                    alt="Info Icon"
                    className="ml-1 cursor-pointer"
                  />
                </Tooltip>
              </div>
              <div className="wm-chart-card-value">
                <Tooltip
                  title={
                    widgetsData?.graphData?.number_data &&
                    widgetsData?.graphData?.number_data[0]?.value
                      ? widgetsData?.graphData?.number_data[0]?.value?.toLocaleString()
                      : "0"
                  }
                  placement="bottom"
                >
                  {widgetsData?.graphData?.number_data &&
                  widgetsData?.graphData?.number_data[0]?.value
                    ? simpleKFormatterOnly(
                        widgetsData?.graphData?.number_data[0]?.value
                      )
                    : "0"}
                </Tooltip>
              </div>
            </div>
            <div
              className="border-right border-color p-4"
              style={{ flex: "1 0 calc(25% - 1.5rem)" }}
            >
              <div className="wm-chart-card-title mb-15">
                {widgetsData?.graphData?.number_data &&
                  widgetsData?.graphData?.number_data[1]?.text}
                <Tooltip
                  title="These are the total number of tickets received by the brand for selected date"
                  placement="bottom"
                >
                  <img
                    src={InfoIcon}
                    alt="Info Icon"
                    className="ml-1 cursor-pointer"
                  />
                  {/* <i className="fa fa-question-circle ml-1" /> */}
                </Tooltip>
              </div>
              <div className="wm-chart-card-value">
                <Tooltip
                  title={
                    widgetsData?.graphData?.number_data &&
                    widgetsData?.graphData?.number_data[1]?.value
                      ? widgetsData?.graphData?.number_data[1]?.value?.toLocaleString()
                      : "0"
                  }
                  placement="bottom"
                >
                  {widgetsData?.graphData?.number_data &&
                  widgetsData?.graphData?.number_data[1]?.value
                    ? simpleKFormatterOnly(
                        widgetsData?.graphData?.number_data[1]?.value
                      )
                    : "0"}
                </Tooltip>
              </div>
            </div>
            <div
              className="border-right border-color p-4"
              style={{ flex: "1 0 calc(25% - 1.5rem)" }}
            >
              <div className="wm-chart-card-title mb-15">
                {widgetsData?.graphData?.number_data &&
                  widgetsData?.graphData?.number_data[2]?.text}
                <Tooltip
                  title="These are the total number of tickets previously received by the brand"
                  placement="bottom"
                >
                  <img
                    src={InfoIcon}
                    alt="Info Icon"
                    className="ml-1 cursor-pointer"
                  />
                  {/* <i className="fa fa-question-circle ml-1" /> */}
                </Tooltip>
              </div>
              <div className="wm-chart-card-value">
                <Tooltip
                  title={
                    widgetsData?.graphData?.number_data &&
                    widgetsData?.graphData?.number_data[2]?.value
                      ? widgetsData?.graphData?.number_data[2]?.value?.toLocaleString()
                      : "0"
                  }
                  placement="bottom"
                >
                  {widgetsData?.graphData?.number_data &&
                  widgetsData?.graphData?.number_data[2]?.value
                    ? simpleKFormatterOnly(
                        widgetsData?.graphData?.number_data[2]?.value
                      )
                    : "0"}
                </Tooltip>
              </div>
            </div>

            <div className="p-4" style={{ flex: "1 0 calc(25% - 1.5rem)" }}>
              <div className="wm-chart-card-title mb-15">
                {widgetsData?.graphData?.number_data &&
                  widgetsData?.graphData?.number_data[3]?.text}
                <Tooltip
                  title="These are the total number of new tickets that are generated every hour"
                  placement="bottom"
                >
                  <img
                    src={InfoIcon}
                    alt="Info Icon"
                    className="ml-1 cursor-pointer"
                  />
                  {/* <i className="fa fa-question-circle ml-1" /> */}
                </Tooltip>
              </div>
              <div className="wm-chart-card-value">
                <Tooltip
                  title={
                    widgetsData?.graphData?.number_data &&
                    widgetsData?.graphData?.number_data[3]?.value
                      ? widgetsData?.graphData?.number_data[3]?.value?.toLocaleString()
                      : "0"
                  }
                  placement="bottom"
                >
                  {widgetsData?.graphData?.number_data &&
                  widgetsData?.graphData?.number_data[3]?.value
                    ? simpleKFormatterOnly(
                        widgetsData?.graphData?.number_data[3]?.value
                      )
                    : "0"}
                </Tooltip>
              </div>
            </div>
          </div>
        ) : widgetsData?.widget_id === "tickets_agent-activity_5" ? (
          <div className="d-flex flex-wrap text-center border-left border-top border-bottom mb-15 border-color w-100 bg__white">
            {widgetsData?.graphData?.number_data &&
              widgetsData?.graphData?.number_data?.map((el, i) => {
                return (
                  <div
                    className="border-right border-color p-4"
                    style={{ flex: "1 0 calc(25% - 1.5rem)" }}
                  >
                    <div className="wm-chart-card-title mb-15 line-height-normal">
                      {el?.text}
                      {el?.text === "Avg. Agent Activity" && (
                        <Tooltip
                          placement="bottom"
                          title="This is the average time that the agents take to respond to a ticket"
                        >
                          {/* <i className="fa fa-question-circle ml-1" /> */}
                          <img
                            src={InfoIcon}
                            alt="Info Icon"
                            className="ml-1 cursor-pointer"
                          />
                        </Tooltip>
                      )}
                      {el?.text === "Avg. Load Per Agent" && (
                        <Tooltip
                          placement="bottom"
                          title="Average Load of agents is calculated by ((Rate of new tickets/Tickets closure per hour) * 100)"
                        >
                          {/* <i className="fa fa-question-circle ml-1" /> */}
                          <img
                            src={InfoIcon}
                            alt="Info Icon"
                            className="ml-1 cursor-pointer"
                          />
                        </Tooltip>
                      )}
                      {el?.text === "Ticket Closure Per Hour" && (
                        <Tooltip
                          placement="bottom"
                          title="This is the average number of tickets agent/supervisor closes in an hour."
                        >
                          {/* <i className="fa fa-question-circle ml-1" /> */}
                          <img
                            src={InfoIcon}
                            alt="Info Icon"
                            className="ml-1 cursor-pointer"
                          />
                        </Tooltip>
                      )}
                    </div>
                    <div className="wm-chart-card-value">
                      <Tooltip
                        title={
                          el?.value
                            ? el?.text === "Avg. Agent Activity"
                              ? secondsToDhms(el?.value)
                              : el?.text === "Ticket Closure Per Hour"
                              ? Number?.isNaN(el?.value)
                                ? el?.value
                                : Number(el?.value)?.toFixed(3)
                              : el?.value?.toLocaleString()
                            : "0"
                        }
                        placement="bottom"
                      >
                        {el?.value
                          ? el?.text === "Avg. Agent Activity"
                            ? secondsToDhms(el?.value)
                            : el?.text === "Ticket Closure Per Hour"
                            ? Number?.isNaN(simpleKFormatterOnly(el?.value))
                              ? simpleKFormatterOnly(el?.value)
                              : Number(
                                  simpleKFormatterOnly(el?.value)
                                )?.toFixed(3)
                            : simpleKFormatterOnly(el?.value)
                          : "0"}
                      </Tooltip>
                    </div>
                  </div>
                );
              })}
          </div>
        ) : widgetsData?.widget_id === "tickets_agent-activity_6" ? (
          <div className="portlet1 p-0 border-radius-4 border-1">
            <div className="border-bottom d-flex align-items-center justify-content-between border-color p-10">
              <div>
                <div className="portlet__title fontSize-16 font-weight500 w-100">
                  {widgetsData?.widget_name || "Agents List"}
                </div>
                <div
                  className="text_regular-gray fontSize-12 line-height-normal"
                  style={{ height: "4.6rem" }}
                >
                  {widgetsData?.widget_description ||
                    "Flr of the tickets: Worked upon that agent."}
                </div>
              </div>
              <div className="d-flex align-items-center">
                {agent?.length > 0 && (
                  <>
                    <Select
                      defaultValue={5}
                      bordered={false}
                      onChange={(e) =>
                        handleGridData(e, widgetsData?.widget_id)
                      }
                      suffixIcon={
                        <img
                          src={
                            authParams?.theme_type === "1"
                              ? accoArrowWhite
                              : accoArrow
                          }
                          alt="acco Arrow"
                          className="accordionArrow p-0"
                        />
                      }
                      popupClassName={
                        authParams?.theme_type === "1"
                          ? "darkTheme"
                          : "lightTheme"
                      }
                      options={selectOption}
                    />
                    {/* <Option value={5}>5</Option>
                      <Option value={10}>10</Option>
                      <Option value={20}>20</Option>
                      <Option value={30}>30</Option> */}
                    {/* </Select> */}
                    <Tooltip title="Download Excel">
                      <Button
                        onClick={handleExport}
                        className="text-center  ml-2 pl-2 pr-2 border-color border-radius-4"
                      >
                        <img
                          src={
                            authParams?.theme_type === "1"
                              ? downloadWhite
                              : download
                          }
                          style={{ maxHeight: "1.8rem" }}
                          alt="download"
                        />
                      </Button>
                    </Tooltip>
                    <Button
                      className="ml-2 border-color btn_Clear border-radius-4 cursor-pointer"
                      style={{ padding: "0.5rem 1rem" }}
                      onClick={() => handleRefresh(widgetsData?.widget_id)}
                    >
                      <Tooltip title="Refresh">
                        <img
                          src={
                            authParams?.theme_type === "1"
                              ? refreshWhite
                              : refresh
                          }
                          alt="refresh"
                          style={{ maxHeight: "1.5rem" }}
                        />
                      </Tooltip>
                    </Button>
                  </>
                )}
              </div>
            </div>
            <div className="p-15">
              {agent?.length > 0 ? (
                <AgentTable
                  tableColumns={AgentsList}
                  dataSource={agent}
                  widget_id={widgetsData?.widget_id}
                  pageSize={pageSize}
                />
              ) : (
                <div className="d-flex full_nodata align-items-center">
                  <div className="w-100 text-center">
                    <div className="Nodata_img mb-15">
                      <img
                        src={somethingWentWrong}
                        alt="no data"
                        style={{ width: "20rem" }}
                      />
                    </div>
                    <div className="text_regular-gray">No Data Found</div>
                  </div>
                </div>
              )}
            </div>
          </div>
        ) : (
          ""
        )
      ) : widgetsData?.widget_id === "tickets_agent-activity_2" ||
        widgetsData?.widget_id === "tickets_agent-activity_3" ||
        widgetsData?.widget_id === "tickets_agent-activity_4" ? (
        ""
      ) : (
        <div
          className={`bg__white d-flex align-items-center justify-content-center mb-15 text-center pt-4 mt-15`}
          style={{
            height:
              widgetsData?.widget_id === "tickets_agent-activity_1" ||
              widgetsData?.widget_id === "tickets_agent-activity_5"
                ? "20rem"
                : "calc(100vh - 15.2rem)",
          }}
        >
          <div className="lds-ring">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
      )}
      {/* {trandView && (
        <Modal
          title={null}
          visible={trandView}
          closable={false}
          className={`trandsPopup ${
            authParams?.theme_type === "1" ? "darkTheme" : "lightTheme"
          }`}
          footer={null}
        >
          <AgentActivityTrends
            setTrandView={setTrandView}
          ></AgentActivityTrends>
        </Modal>
      )} */}
    </>
  );
};

export default AgentActivityPage;
